
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quizzes/[quizName]",
      function () {
        return require("private-next-pages/quizzes/[quizName]/index.tsx");
      }
    ]);
  